import React, { useEffect } from 'react';

export default function MobileWarning() {
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  }, [isMobile]);

  if (!isMobile) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999999,
      backgroundColor: '#1A1A1A',
      display: 'flex', flexDirection: 'column',
      fontFamily: 'Arial, sans-serif',
      padding: '60px 32px',
      boxSizing: 'border-box',
      width: '100vw',
      height: '100vh',
    }}>
      <img src="/logo-compify.svg" alt="Compify" style={{ width: '130px', marginBottom: '60px' }} />
      <p style={{ color: '#FF0066', fontSize: '9px', letterSpacing: '2px', fontWeight: '700', margin: '0 0 16px' }}>
        NON DISPONIBLE SUR MOBILE
      </p>
      <h1 style={{ color: '#fff', fontSize: '28px', fontWeight: '900', margin: '0 0 20px', lineHeight: 1.3 }}>
        Compify n'est pas disponible sur mobile.
      </h1>
      <p style={{ color: '#555', fontSize: '14px', lineHeight: 1.8, margin: 0 }}>
        Ouvrez compify.fr sur votre ordinateur pour créer votre composite card.
      </p>
    </div>
  );
}